import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './supporting-detail-card.component.scss';
var SupportingDetailCard = /** @class */ (function (_super) {
    tslib_1.__extends(SupportingDetailCard, _super);
    function SupportingDetailCard(element) {
        return _super.call(this, element) || this;
    }
    SupportingDetailCard.prototype.init = function () { };
    SupportingDetailCard.prototype.bindEvents = function () { };
    return SupportingDetailCard;
}(Base));
export { SupportingDetailCard };



//////////////////
// WEBPACK FOOTER
// ./components/supporting-detail-card/supporting-detail-card.component.ts
// module id = 521
// module chunks = 0